module.exports = __webpack_public_path__ + "static/media/corporate-services-icon-selected.c89c4045.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/corporate-services-icon-selected.svg
// module id = 1927
// module chunks = 0